import React, { useState, Fragment, useEffect } from "react";

import { Listbox, Transition } from "@headlessui/react";
import { CheckIcon, SelectorIcon } from "@heroicons/react/solid";

const Dropdown = ({ handleItem, items, handleClear, clearItem, disabled }) => {

  const [selectedItem, setSelectedItem] = useState([]);
  
  function handleChange(item) {
    setSelectedItem(item); //Envía el valor para mostrarlo en Dropdown
    handleItem(item);     //Envía el valor para manejarlo en componente padre 
    handleClear(false);
  }

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  
  return (
    <Listbox value={selectedItem} onChange={handleChange}>
      {!disabled 
        ? <div className={"relative mb-1"}>
            <Listbox.Button 
              className={`relative w-full py-2 pl-3 pr-10 | text-left sm:text-sm bg-white rounded-none shadow-md cursor-default |
                          focus:outline-none focus-visible:ring-2 focus-visible:ring-opacity-75 focus-visible:ring-white
                          focus-visible:ring-offset-green-300 focus-visible:ring-offset-2 focus-visible:border-green-500`}
            >
              <span className={"block truncate h-5"}>
                {clearItem ? "" : selectedItem.name}
              </span>
              <span className={"absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"}>
                <SelectorIcon
                  className={"w-5 h-5 text-gray-400"}
                  aria-hidden={"true"}
                />
              </span>
            </Listbox.Button>
            <Transition
              as={ Fragment }
              leave={"transition ease-in duration-100"}
              leaveFrom={"opacity-100"}
              leaveTo={"opacity-0"}
            >
              <Listbox.Options 
                className={`absolute w-full py-1 mt-1 z-10 overflow-auto text-base bg-white rounded-none 
                            shadow-lg max-h-60 ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm`}
              >
                {items.map((item) => (
                  <Listbox.Option
                    key={item.index}
                    className={({ active }) =>
                      `${active ? "text-green-800 hover:bg-green-100" : "text-gray-800"}
                              cursor-default select-none relative py-2 pl-10 pr-4`
                    }
                    value={ item }
                  >
                    {({ selected, active }) => (
                      <>
                        <span 
                        className={`${ (!clearItem && selected) 
                                        ? "font-medium" 
                                        : "font-normal" 
                                    } block truncate`
                        }
                        >
                          {item.name}
                        </span>
                        {(!clearItem && selected) 
                          ? (<span
                              className={`${active ? "text-green-600" : "text-green-600"}
                                          absolute inset-y-0 left-0 flex items-center pl-3`
                              }
                            >
                            <CheckIcon className={"w-5 h-5"} aria-hidden={"true"} />
                          </span>
                          ) : null
                        }
                      </>
                    )}
                  </Listbox.Option>
                ))}
              </Listbox.Options>
            </Transition>
          </div>
        : <div>
            <Listbox.Button 
              className={`relative w-full py-2 pl-3 pr-10 | text-left sm:text-sm bg-gray-200 rounded-none 
                          shadow-inner cursor-default | focus:outline-none`}
            >
              <span className={"block truncate h-5"}>
                {}
              </span>
              <span className={"absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none"}>
                <SelectorIcon
                  className={"w-4 h-4 text-gray-300"}
                  aria-hidden={"true"}
                />
              </span>
            </Listbox.Button>
          </div>
      }
    </Listbox>
  );
}

export default Dropdown
